import { useMemo } from 'react';
import { useGetProperty } from 'crm-object-board-core/properties';
import { useObjectTypeDefinition } from 'crm-object-board-core/objectTypeDefinition';
export const useTitleCardProperty = () => {
  const objectTypeDef = useObjectTypeDefinition();
  const getProperty = useGetProperty();
  return useMemo(() => {
    return objectTypeDef && objectTypeDef.primaryDisplayLabelPropertyName ? getProperty(objectTypeDef.primaryDisplayLabelPropertyName) : undefined;
  }, [objectTypeDef, getProperty]);
};